import React from 'react';
import {FileVisibilityHelper} from "../../Files/FileVisibilityHelper";
import {service as FileUploadService} from "../../../../Services/FileUploadService";

export const SurveyFormInputFileViewer = props => {
    const {
        fileUpload,
        hideFileVisibilityHelper = false,
    } = props;
    
    const onClick = (event) => {
        return FileUploadService.DownloadFile(fileUpload?.fileName, fileUpload.fileUploadId)
    }
    
    if (fileUpload) {
        return <span>
                <a className="link-primary" onClick={onClick}>
                    {
                        fileUpload.name ?? "N/A"
                    }
                </a>
                { hideFileVisibilityHelper ? null : <FileVisibilityHelper file={fileUpload}/> }
            </span>;
    }
    
    return null;
};

